/* js/components/GeoLocationStartButton.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import Switch from './Switch.svelte';

import {
	geoLocationManager,
	GeolocationEventType,
	GeoLocationServiceState
} from '../GeoLocationManager.js';

import { onMount, onDestroy } from 'svelte';
import { notificationStore } from '../notificationStore';

function create_else_block(ctx) {
	let div;
	let switch_1;
	let t0;
	let p;
	let current;

	switch_1 = new Switch({
			props: {
				checked: /*started*/ ctx[1],
				$$slots: {
					unCheckedIcon: [create_unCheckedIcon_slot],
					checkedIcon: [create_checkedIcon_slot]
				},
				$$scope: { ctx }
			}
		});

	switch_1.$on("change", /*onChange*/ ctx[2]);

	return {
		c() {
			div = element("div");
			create_component(switch_1.$$.fragment);
			t0 = space();
			p = element("p");
			p.textContent = "GPS";
			attr(p, "class", "svelte-ezhopq");
			attr(div, "class", "switch-container svelte-ezhopq");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(switch_1, div, null);
			append(div, t0);
			append(div, p);
			current = true;
		},
		p(ctx, dirty) {
			const switch_1_changes = {};
			if (dirty & /*started*/ 2) switch_1_changes.checked = /*started*/ ctx[1];

			if (dirty & /*$$scope*/ 64) {
				switch_1_changes.$$scope = { dirty, ctx };
			}

			switch_1.$set(switch_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(switch_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(switch_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(switch_1);
		}
	};
}

// (70:4) {#if unsupportedDevice}
function create_if_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");
			p.textContent = "Cet appareil ne supporte pas la géolocalisation";
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (77:12) 
function create_checkedIcon_slot(ctx) {
	let span;

	return {
		c() {
			span = element("span");
			attr(span, "slot", "checkedIcon");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (78:12) 
function create_unCheckedIcon_slot(ctx) {
	let span;

	return {
		c() {
			span = element("span");
			attr(span, "slot", "unCheckedIcon");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*unsupportedDevice*/ ctx[0]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "_root svelte-ezhopq");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(div, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let permisssionIsDenied = geoLocationManager.serviceState == GeoLocationServiceState.PERMISSION_DENIED;
	let unsupportedDevice = geoLocationManager.serviceState == GeoLocationServiceState.UNSUPPORTED_DEVICE;
	let started = geoLocationManager.isStarted;

	function onGeoLocationUpdate(event) {
		$$invalidate(1, started = true);
	}

	function onGeoLocationError(event) {
		permisssionIsDenied = geoLocationManager.serviceState == GeoLocationServiceState.PERMISSION_DENIED;
		$$invalidate(0, unsupportedDevice = geoLocationManager.serviceState == GeoLocationServiceState.UNSUPPORTED_DEVICE);

		if (permisssionIsDenied || unsupportedDevice) {
			$$invalidate(1, started = false);
			geoLocationManager.stop();
			console.log("permission denied");
			notificationStore.publishError("permissions refusées");
		}

		if (event.value.error.code == 2) {
			$$invalidate(1, started = false);
			geoLocationManager.stop();
			console.log("service unavailable");
			notificationStore.publishError("le service n'est pas disponible");
		}

		if (event.value.error.code == 3) {
			$$invalidate(1, started = false);
			geoLocationManager.stop();
			console.log("timeout");
			notificationStore.publishError("timeout");
		}
	}

	onMount(() => {
		geoLocationManager.addEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.addEventListener(GeolocationEventType.locationError, onGeoLocationError);
	});

	onDestroy(() => {
		geoLocationManager.removeEventListener(GeolocationEventType.significantCoords, onGeoLocationUpdate);
		geoLocationManager.removeEventListener(GeolocationEventType.locationError, onGeoLocationError);
	});

	function onChange(e) {
		const { checked } = e.detail;

		if (checked) {
			console.log("trying to start geolocation service");
			$$invalidate(1, started = checked);
			geoLocationManager.start();
		} else {
			console.log("trying to stop geolocation service");
			$$invalidate(1, started = checked);
			geoLocationManager.stop();
		}
	}

	return [unsupportedDevice, started, onChange];
}

class GeoLocationStartButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default GeoLocationStartButton;